module.exports = __webpack_public_path__ + "static/media/pl-PL.313dd424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/pl-PL.png
// module id = 951
// module chunks = 0